export default __webpack_public_path__ + "static/a1-1-d177df64be58e5fcf0f169477d0bc2a1.jpg";